import { Collapse, Row, Col, Tooltip, Input, Form } from "antd";
import React, { createRef, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "../../../components/Collapse";
import { inject, observer } from "mobx-react";

import "../../../styles/components.scss";
import { dataSuperior, dataSuperior0 } from "../../../utils/Utils";
import { toJS } from "mobx";
import GoalsStore from "../../../DataStores/GoalsStore";
const { Panel } = Collapse;

const Goals = ({ ToolStore, displayAll }) => {
  const [form] = Form.useForm();

  const [display, setDisplay] = useState(false);
  useEffect(() => {
    form.setFieldsValue(GoalsStore.toFormatJson());

    if (
      toJS(GoalsStore.data).length > 0 &&
      toJS(GoalsStore.data)[0].value[0].display != -1 &&
      toJS(GoalsStore.data)[0].value[0].display
    ) {
      setDisplay(true);
    } else {
      setDisplay(false || displayAll);
    }
  }, [GoalsStore.data, ToolStore.numbersToTest, ToolStore.conditions]);

  const toGetElement = (first, second) => {
    var element = GoalsStore.getData()[0]
      .value.filter((a) => a.fieldName == first)[0]
      .value.filter((b) => b.fieldName == second)[0];
    return element;
  };

  const onChange = (first, e) => {
    if (!GoalsStore.changed[first]) {
      var json = form.getFieldsValue();
      json[first] = parseFloat(e.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...GoalsStore.changed };
    c[first] = true;
    GoalsStore.setChanged(c);
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = GoalsStore.defaultsValues[id];
      form.setFieldsValue(json);
      const c = { ...GoalsStore.changed };

      c[id] = false;
      GoalsStore.setChanged(c);
    }
  };

  const elements = () => {
    const targetAnnualGrowth = GoalsStore.getData()[0].value[0];
    if (displayAll) {
      return (
        <Row>
          <Col xl={10} md={24}>
            <Row>
              <Col xl={2} md={2}>
                {/* <Tooltip
                  color="#EBEBEA"
                  fontFamily="Gotham"
                  fontSize="20px"
                  style={{ textColor: "#6a6e80" }}
                  placement="rightTop"
                  title={<FormattedMessage id="targetAnnualGrowthTooltip" />}
                >
                  <img src="/images/icons/bull.svg" />
                </Tooltip> */}
              </Col>
              <Col md={12} xl={14}>
                <span
                  className="roi--label-section"
                  style={{ marginTop: "10px" }}
                >
                  <FormattedMessage id="targetAnnualGrowth" />
                </span>
              </Col>
              <Col md={6} xl={8}>
                <Form.Item
                  name="targetAnnualGrowth"
                  rules={[{ validator: dataSuperior }]}
                >
                  <Input
                    type="number"
                    suffix={
                      targetAnnualGrowth.suffix && targetAnnualGrowth.suffix
                    }
                    prefix={
                      targetAnnualGrowth.prefix && targetAnnualGrowth.prefix
                    }
                    className={
                      !GoalsStore.changed.targetAnnualGrowth &&
                      "roi--input-default"
                    }
                    onChange={(e) => onChange("targetAnnualGrowth", e)}
                    onBlur={(e) => onBlur(e, "targetAnnualGrowth")}
                  ></Input>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xl={2} md={0} xs={0}></Col> <Col xl={10} md={24} xs={24}></Col>
        </Row>
      );
    }
    if (targetAnnualGrowth.display != -1 && targetAnnualGrowth.display) {
      return (
        <Row>
          {targetAnnualGrowth.display != -1 && targetAnnualGrowth.display && (
            <>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}></Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="targetAnnualGrowth" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="targetAnnualGrowth"
                      rules={[{ validator: dataSuperior }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          targetAnnualGrowth.suffix && targetAnnualGrowth.suffix
                        }
                        prefix={
                          targetAnnualGrowth.prefix && targetAnnualGrowth.prefix
                        }
                        className={
                          !GoalsStore.changed.targetAnnualGrowth &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("targetAnnualGrowth", e)}
                        onBlur={(e) => onBlur(e, "targetAnnualGrowth")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>{" "}
            </>
          )}{" "}
        </Row>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <Form
        form={form}
        onChange={() => GoalsStore.toUpdateConversion(form.getFieldsValue())}
      >
        {(display || displayAll) && (
          <CollapseComponent
            style={{ marginBottom: "2vh", marginTop: "2vh" }}
            headerText={<FormattedMessage id="goalsAndObjectives" />}
            classNameHeader="roi--collapse-header-green"
            content={GoalsStore.data != null && <>{elements()}</>}
          ></CollapseComponent>
        )}
      </Form>
    </>
  );
};

export default inject("ToolStore")(observer(Goals));
